module.exports = __webpack_public_path__ + "img/register-up.8ccb71fe.png";